import React, { useState, useMemo, useEffect } from "react";
import { Card, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getvehicleType,
  deletevehicleType,
} from "../../store/slices/vehicletype";
import DeleteModal from "./deletepopup";

export default function Vehicle() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { vehicleTypeList = [], loading } = useSelector((state) => state.vehicleType);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const fetchvehicle = async () => {
    try {
      await dispatch(getvehicleType()).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchvehicle();
  }, [dispatch]);

  const filteredData = useMemo(() => {
    return vehicleTypeList.filter((item) =>
      item.name?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, vehicleTypeList]);

  const pagelimit = 25;
  const totalPages = Math.ceil(filteredData.length / pagelimit);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pagelimit,
    currentPage * pagelimit,
  );

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deletevehicleType(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const changePage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/vehicle")}
          >
            Vehicles
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addvehicle")}
        >
          + Add Vehicle
        </button>
      </div>

      <Container fluid>
        <Card className="table-border mb-5">
          <Card.Body>
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th className="text-center">#</th>

                    <th className="text-center">Name</th>

                    <th className="text-center">Description</th>
                    <th className="text-center">Details</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="d-flex flex-column align-items-center gap-1">
                            <div className="skeleton skeleton-text small"></div>
                            <div className="skeleton skeleton-text small"></div>
                          </div>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : paginatedData.map((item, index) => (
                      <tr key={item._id}>

                        <td className="text-center">
                          {(currentPage - 1) * pagelimit + index + 1}
                        </td>

                        <td className="text-center" style={{ maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {item.name}
                        </td>

                        <td className="text-center">
                          {item.description?.length > 30 ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>{item.description}</Tooltip>}
                            >
                              <span>{item.description.substring(0, 30)}...</span>
                            </OverlayTrigger>
                          ) : (
                            item.description
                          )}
                        </td>

                        <td className="text-center">
                          <div className="d-flex flex-column">
                            <span>
                              <strong>Capacity:</strong> {item.capacity}
                            </span>
                            <span>
                              <strong>Fuel:</strong> {item.fuelType}
                            </span>
                          </div>
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group">
                            <button
                              onClick={() =>
                                navigate(`/admin/editvehicle/${item._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(item._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    variant={
                      currentPage === i + 1 ? "primary" : "outline-secondary"
                    }
                    onClick={() => changePage(i + 1)}
                  >
                    className=
                    {`button-between ${currentPage === i + 1 ? "active-page" : ""
                      }`}
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* delete model popup */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
